import React from "react";
import ReactDOM from "react-dom";

import { BaseProviders } from "./components/shared/BaseProviders.jsx";
import "@assets/vendors/style";

export function withAppProviders(InnerComponent, { includeRouter = true } = {}) {
   return function Wrapped(props) {
      return (
         <BaseProviders includeConfigProvider={true} includeRouter={includeRouter}>
            <InnerComponent {...props} />
         </BaseProviders>
      );
   };
}

// Utility to mount any component into a DOM node
export function mountWidget(Component, domNode, props = {}) {
   const Wrapped = withAppProviders(Component);
   ReactDOM.render(<Wrapped {...props} />, domNode);
}
